<script setup lang="ts">
  import { computed } from 'vue';
  import { Checkbox } from '@/shared/ui';
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import FieldRef from './FieldRef.vue';
  import LabSection from './LabSection.vue';
  import ReportTable from './ReportTable.vue';

  const lab = useMatrixFillLabContext();

  const selectedCount = computed(() => lab.effectiveReportFieldIds.value.size);
  const usesTags = computed(() => lab.reportFieldIds.value === null && lab.taggedReportFieldIds.value.length > 0);

  function isSelected(id: string): boolean {
    return lab.effectiveReportFieldIds.value.has(id);
  }
</script>

<template>
  <LabSection
    title="Relatório e Excel"
    data-testid="lab-report"
    :badge="`${lab.responses.value.length} resposta(s)`"
    hint="buildReportTable lê as respostas salvas: uma coluna por campo; célula escondida por regra sai vazia. O Excel é a mesma tabela."
  >
    <details class="rounded-md border border-[var(--color-gray-02)]">
      <summary class="cursor-pointer px-2 py-1.5 font-medium">
        Campos no relatório ({{ selectedCount }})
        <span
          v-if="usesTags"
          class="ml-1 font-normal text-[var(--color-gray-05)]"
        >
          padrão da matriz (campos marcados como relatório)
        </span>
        <span
          v-else-if="lab.reportFieldIds.value === null"
          class="ml-1 font-normal text-[var(--color-gray-05)]"
        >
          todos, porque a matriz não marca nenhum
        </span>
      </summary>
      <div class="max-h-40 overflow-auto border-t border-[var(--color-gray-02)] p-1.5">
        <label
          v-for="field in lab.fieldOptions.value"
          :key="field.id"
          class="flex cursor-pointer items-center gap-2 py-0.5"
        >
          <Checkbox
            :id="`report-field-${field.id}`"
            :checked="isSelected(field.id)"
            @toggle="lab.toggleReportField(field.id)"
          />
          <FieldRef
            :id="field.id"
            :label="field.label"
            :locate="false"
          />
          <span
            v-if="lab.taggedReportFieldIds.value.includes(field.id)"
            class="ml-auto shrink-0 rounded-full bg-sky-100 px-1.5 py-0.5 text-[10px] font-semibold text-sky-800"
          >
            relatório
          </span>
        </label>
      </div>
      <button
        v-if="lab.reportFieldIds.value !== null"
        type="button"
        class="px-2 pb-1.5 text-[var(--color-gray-05)] underline"
        @click="lab.reportFieldIds.value = null"
      >
        Voltar ao padrão da matriz
      </button>
    </details>

    <ReportTable />
  </LabSection>
</template>
